import {
  EntityList,
  EntityListProps,
  renderDate,
  renderEnum,
  renderStatusIcon,
} from 'components/EntityList'
import { Proving, User } from 'gql.generated'
import { Box } from 'grid'
import { ConstrainMode, SelectionMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

type ReadProvings_workers = any

export type ProvingsByMaintenanceHeadListProps =
  EntityListProps<ReadProvings_workers>

export const ProvingsByMaintenanceHeadList: React.FunctionComponent<
  ProvingsByMaintenanceHeadListProps
> = ({ items, ...props }) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('status', {
        onRender: renderStatusIcon,
        getGroupValue: (item: Proving) => t(`enum.status.${item.status}`),
        minWidth: 40,
        maxWidth: 60,

        ungroupable: true,
      }),
      fieldColumn('dateFrom', {
        onRender: renderDate,
        isSorted: true,

        ungroupable: true,
      }),
      fieldColumn('dateTo', {
        onRender: renderDate,
        ungroupable: true,
      }),
      fieldColumn('id', { ungroupable: true }),
      fieldColumn('title', {
        ungroupable: true,
        minWidth: 320,
      }),
      fieldColumn('provingGround.title', {
        onRender: (item, i, col) => {
          return `${item.provingGround!.title}, ${
            item.provingGround!.countryCode
          }`
        },
        ungroupable: true,
        getGroupValue: (item: Proving) =>
          `${item.provingGround!.title}, ${item.provingGround!.countryCode}`,
      }),
      fieldColumn('maintenanceHead', {
        onRender: (item, i, col) => {
          return (
            <div key={i}>
              {item.maintenanceHead.map((user: User, a: any) => {
                return (
                  <Box key={a} style={{ whiteSpace: 'pre-line' }}>
                    {user.name}
                  </Box>
                )
              })}
            </div>
          )
        },
        getGroupValue: (item: any) => {
          let result = '[Keine Meister zugeordnet]'
          if (item.groupingKey) {
            result = `${item.groupingKey}`
          }
          return result
        },
        minWidth: 105,
        isGrouped: true,
        isSorted: true,
      }),

      fieldColumn('editor', {
        onRender: (item, i, col) => {
          return (
            <div key={i}>
              {item.editor.map((user: User, a: any) => {
                return (
                  <Box key={a} style={{ whiteSpace: 'pre-line' }}>
                    {user.name}
                  </Box>
                )
              })}
            </div>
          )
        },
        getGroupValue: (item: Proving) => {
          let result = '[Keine Erprobungsorganisation zugeordnet]'
          if (item.editor) {
            item.editor.forEach((user: User) => {
              result = `${user.name}`
            })
          }
          return result
        },
        minWidth: 105,
      }),
      fieldColumn('responsible', {
        onRender: (item, i, col) => {
          return (
            <div key={i}>
              {item.responsible.map((user: User, a: any) => {
                return (
                  <Box key={a} style={{ whiteSpace: 'pre-line' }}>
                    {user.name}
                  </Box>
                )
              })}
            </div>
          )
        },
        getGroupValue: (item: Proving) => {
          let result = ''
          if (item.responsible) {
            item.responsible.forEach((user: User) => {
              result = `${result} ${user.name}`
            })
          }
          return result
        },
        minWidth: 105,
        ungroupable: true,
      }),
      fieldColumn('department', { ungroupable: true }),
      fieldColumn('status', {
        onRender: renderEnum(t, 'status'),
        getGroupValue: (item: Proving) => t(`enum.status.${item.status}`),
        minWidth: 40,
        maxWidth: 60,

        ungroupable: true,
      }),
    ],
    [fieldColumn, t]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      sortHighestGroup={true}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      {...props}
    />
  )
}
